import { useQueryClient } from "@tanstack/react-query";

import { meQueryOptions } from "@/features/auth";
import { $api } from "@/shared/api";

// Сохраняет обложку профиля (`PATCH /api/me`) и кладёт ответ в кэш текущего пользователя.
export const useUpdateCover = () => {
  const queryClient = useQueryClient();
  return $api.useMutation("patch", "/api/me", {
    onSuccess: (user) => {
      queryClient.setQueryData(meQueryOptions().queryKey, user);
    },
  });
};
